"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SQToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "totalSupply",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burnFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getMinter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "destination",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SQToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "SQToken";
    }
    deploy(_minter, totalSupply, overrides) {
        return super.deploy(_minter, totalSupply, overrides || {});
    }
    getDeployTransaction(_minter, totalSupply, overrides) {
        return super.getDeployTransaction(_minter, totalSupply, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SQToken__factory = SQToken__factory;
SQToken__factory.bytecode = _bytecode;
SQToken__factory.abi = _abi;
